import React from 'react';

import { Navbar, Nav, NavItem } from 'reactstrap';

const Footer = () => {
  return (
    <Navbar>
      <Nav navbar>
        <NavItem>Copyright © 2021 Ironlist. All right reserved</NavItem>
      </Nav>
    </Navbar>
  );
};

export default Footer;
